/**
 * Shared list of known suppliers used across:
 * - Inventory Add/Edit Item modal (Supplier field)
 * - Pending Import Review modal (Supplier field)
 * - Add to Order modal (Order From dropdown)
 * - Settings > Orders > Order From list (default entries)
 */
export const KNOWN_SUPPLIERS = [
  'HD Supply',
  'Grainger',
  'Home Depot',
  'McMaster-Carr',
  'Fastenal',
  'Zoro',
  'Amazon',
  'Walmart',
  'U-Line',
  'MSC Industrial',
  'WebstaurantStore',
  'SupplyWorks',
  'DSSI',
  'Global Industrial',
  'USA Clean',
  'Direct Supply',
  'Carstens',
  'Parts Town',
  'Genuine Replacement Parts',
  'Supply House',
  'Kpaul Supply',
];
